import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import {
  USER_PROFILE_SET_PROFILE_LOADING,
  USER_PROFILE_GETPROFILE_SUCCESS,
  USER_PROFILE_GETPROFILE_FAIL,
  USER_PROFILE_GETPROFILE_REQUEST,
  USER_PROFILE_LOGOUT_SUCCESS,
  USER_PROFILE_LOGOUT_FAIL,
  USER_PROFILE_LOGIN_SUCCESS,
  USER_PROFILE_LOGIN_FAIL,
  USER_PROFILE_LOGIN_CLEARERROR,
} from './actions';

const data = handleActions(
  {
    // [USER_PROFILE_SET_PROFILE]: (state, { payload }) => payload,
    [USER_PROFILE_GETPROFILE_SUCCESS]: (state, { payload }) => payload.result,
    [USER_PROFILE_GETPROFILE_FAIL]: () => null,
    [USER_PROFILE_LOGOUT_SUCCESS]: () => null,
  },
  null
);

const loading = handleActions(
  {
    // [USER_PROFILE_SET_PROFILE_LOADING]: (state, { payload }) => payload,
    [USER_PROFILE_GETPROFILE_REQUEST]: () => true,
    [USER_PROFILE_GETPROFILE_SUCCESS]: () => false,
    [USER_PROFILE_GETPROFILE_FAIL]: () => false,
  },
  true
);

const error = handleActions(
  {
    [USER_PROFILE_LOGIN_SUCCESS]: () => null,
    [USER_PROFILE_LOGIN_FAIL]: (state, { payload }) => payload.error,
    [USER_PROFILE_LOGOUT_SUCCESS]: () => null,
    [USER_PROFILE_LOGIN_CLEARERROR]: () => null,
  },
  null
);

export default combineReducers({
  data,
  loading,
  error,
});
